/**
 * Persist specific properties of the store state.
 * Note: currentVersion is NOT persisted as it always comes from Config.
 *
 * @param state Current VersionHistory state
 * @return Partial state to persist
 */
export default (state: IKeyValue) => ({
	lastSeenVersion: state.lastSeenVersion,
	seenVersions: state.seenVersions,
	versionFirstSeenDates: state.versionFirstSeenDates,
});
